import { useMediaQuery } from "@mui/material";

const MOBILE_BREAKPOINT = "(max-width: 599px)";

export const useIsMobile = (): boolean => {
  return useMediaQuery(MOBILE_BREAKPOINT);
};
